package `data`.db.delight

import app.cash.sqldelight.Query
import app.cash.sqldelight.SuspendingTransacterImpl
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlCursor
import app.cash.sqldelight.db.SqlDriver
import kotlin.Any
import kotlin.Double
import kotlin.Long
import kotlin.String

public class KinoshkaDbQueries(
  driver: SqlDriver,
) : SuspendingTransacterImpl(driver) {
  public fun <T : Any> getAllFavoriteVideo(mapper: (
    id: Long,
    imdbId: String?,
    imageUrl: String?,
    title: String?,
    isTvShow: Long,
    isDeleted: Long,
    changedAt: String?,
  ) -> T): Query<T> = Query(-1_803_085_395, arrayOf("FavoriteVideo"), driver, "KinoshkaDb.sq",
      "getAllFavoriteVideo", "SELECT * FROM FavoriteVideo") { cursor ->
    mapper(
      cursor.getLong(0)!!,
      cursor.getString(1),
      cursor.getString(2),
      cursor.getString(3),
      cursor.getLong(4)!!,
      cursor.getLong(5)!!,
      cursor.getString(6)
    )
  }

  public fun getAllFavoriteVideo(): Query<FavoriteVideo> = getAllFavoriteVideo { id, imdbId,
      imageUrl, title, isTvShow, isDeleted, changedAt ->
    FavoriteVideo(
      id,
      imdbId,
      imageUrl,
      title,
      isTvShow,
      isDeleted,
      changedAt
    )
  }

  public fun isVideoFavorite(id: Long): Query<Long> = IsVideoFavoriteQuery(id) { cursor ->
    cursor.getLong(0)!!
  }

  public fun <T : Any> getAllWatchProgress(mapper: (
    videoId: Long,
    imdbId: String?,
    isTvShow: Long,
    seasonNumber: Long,
    episodeNumber: Long,
    positionSec: Long,
    durationSec: Long,
    progress: Double,
    engagedSec: Long,
    status: String,
    title: String?,
    imageUrl: String?,
    backdropUrl: String?,
    hiddenFromContinue: Long,
    isDeleted: Long,
    changedAt: String,
    audio: String?,
    quality: String?,
    subtitles: String?,
  ) -> T): Query<T> = Query(-2_037_528_182, arrayOf("WatchProgress"), driver, "KinoshkaDb.sq",
      "getAllWatchProgress", "SELECT * FROM WatchProgress") { cursor ->
    mapper(
      cursor.getLong(0)!!,
      cursor.getString(1),
      cursor.getLong(2)!!,
      cursor.getLong(3)!!,
      cursor.getLong(4)!!,
      cursor.getLong(5)!!,
      cursor.getLong(6)!!,
      cursor.getDouble(7)!!,
      cursor.getLong(8)!!,
      cursor.getString(9)!!,
      cursor.getString(10),
      cursor.getString(11),
      cursor.getString(12),
      cursor.getLong(13)!!,
      cursor.getLong(14)!!,
      cursor.getString(15)!!,
      cursor.getString(16),
      cursor.getString(17),
      cursor.getString(18)
    )
  }

  public fun getAllWatchProgress(): Query<WatchProgress> = getAllWatchProgress { videoId, imdbId,
      isTvShow, seasonNumber, episodeNumber, positionSec, durationSec, progress, engagedSec, status,
      title, imageUrl, backdropUrl, hiddenFromContinue, isDeleted, changedAt, audio, quality,
      subtitles ->
    WatchProgress(
      videoId,
      imdbId,
      isTvShow,
      seasonNumber,
      episodeNumber,
      positionSec,
      durationSec,
      progress,
      engagedSec,
      status,
      title,
      imageUrl,
      backdropUrl,
      hiddenFromContinue,
      isDeleted,
      changedAt,
      audio,
      quality,
      subtitles
    )
  }

  public fun <T : Any> findWatchProgress(
    videoId: Long,
    seasonNumber: Long,
    episodeNumber: Long,
    mapper: (
      videoId: Long,
      imdbId: String?,
      isTvShow: Long,
      seasonNumber: Long,
      episodeNumber: Long,
      positionSec: Long,
      durationSec: Long,
      progress: Double,
      engagedSec: Long,
      status: String,
      title: String?,
      imageUrl: String?,
      backdropUrl: String?,
      hiddenFromContinue: Long,
      isDeleted: Long,
      changedAt: String,
      audio: String?,
      quality: String?,
      subtitles: String?,
    ) -> T,
  ): Query<T> = FindWatchProgressQuery(videoId, seasonNumber, episodeNumber) { cursor ->
    mapper(
      cursor.getLong(0)!!,
      cursor.getString(1),
      cursor.getLong(2)!!,
      cursor.getLong(3)!!,
      cursor.getLong(4)!!,
      cursor.getLong(5)!!,
      cursor.getLong(6)!!,
      cursor.getDouble(7)!!,
      cursor.getLong(8)!!,
      cursor.getString(9)!!,
      cursor.getString(10),
      cursor.getString(11),
      cursor.getString(12),
      cursor.getLong(13)!!,
      cursor.getLong(14)!!,
      cursor.getString(15)!!,
      cursor.getString(16),
      cursor.getString(17),
      cursor.getString(18)
    )
  }

  public fun findWatchProgress(
    videoId: Long,
    seasonNumber: Long,
    episodeNumber: Long,
  ): Query<WatchProgress> = findWatchProgress(videoId, seasonNumber, episodeNumber) { videoId_,
      imdbId, isTvShow, seasonNumber_, episodeNumber_, positionSec, durationSec, progress,
      engagedSec, status, title, imageUrl, backdropUrl, hiddenFromContinue, isDeleted, changedAt,
      audio, quality, subtitles ->
    WatchProgress(
      videoId_,
      imdbId,
      isTvShow,
      seasonNumber_,
      episodeNumber_,
      positionSec,
      durationSec,
      progress,
      engagedSec,
      status,
      title,
      imageUrl,
      backdropUrl,
      hiddenFromContinue,
      isDeleted,
      changedAt,
      audio,
      quality,
      subtitles
    )
  }

  public suspend fun insertFavoriteVideo(
    id: Long?,
    imdbId: String?,
    imageUrl: String?,
    title: String?,
    isTvShow: Long,
    isDeleted: Long,
    changedAt: String?,
  ) {
    driver.execute(-1_427_574_753, """
        |INSERT OR REPLACE INTO FavoriteVideo(id, imdbId,imageUrl,title, isTvShow, isDeleted, changedAt)
        |VALUES (?,?,?,?,?,?,?)
        """.trimMargin(), 7) {
          bindLong(0, id)
          bindString(1, imdbId)
          bindString(2, imageUrl)
          bindString(3, title)
          bindLong(4, isTvShow)
          bindLong(5, isDeleted)
          bindString(6, changedAt)
        }.await()
    notifyQueries(-1_427_574_753) { emit ->
      emit("FavoriteVideo")
    }
  }

  public suspend fun deleteAllFavorites() {
    driver.execute(723_340_744, """DELETE FROM FavoriteVideo""", 0).await()
    notifyQueries(723_340_744) { emit ->
      emit("FavoriteVideo")
    }
  }

  public suspend fun deleteFavoriteVideo(id: Long) {
    driver.execute(8_849_005, """
        |DELETE FROM FavoriteVideo
        |WHERE id=?
        """.trimMargin(), 1) {
          bindLong(0, id)
        }.await()
    notifyQueries(8_849_005) { emit ->
      emit("FavoriteVideo")
    }
  }

  public suspend fun insertWatchProgress(
    videoId: Long,
    imdbId: String?,
    isTvShow: Long,
    seasonNumber: Long,
    episodeNumber: Long,
    positionSec: Long,
    durationSec: Long,
    progress: Double,
    engagedSec: Long,
    status: String,
    title: String?,
    imageUrl: String?,
    backdropUrl: String?,
    hiddenFromContinue: Long,
    isDeleted: Long,
    changedAt: String,
    audio: String?,
    quality: String?,
    subtitles: String?,
  ) {
    driver.execute(-1_662_017_540, """
        |INSERT OR REPLACE INTO WatchProgress(
        |videoId, imdbId, isTvShow, seasonNumber, episodeNumber,
        |positionSec, durationSec, progress, engagedSec, status,
        |title, imageUrl, backdropUrl, hiddenFromContinue, isDeleted, changedAt,
        |audio, quality, subtitles
        |)
        |VALUES (?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?)
        """.trimMargin(), 19) {
          bindLong(0, videoId)
          bindString(1, imdbId)
          bindLong(2, isTvShow)
          bindLong(3, seasonNumber)
          bindLong(4, episodeNumber)
          bindLong(5, positionSec)
          bindLong(6, durationSec)
          bindDouble(7, progress)
          bindLong(8, engagedSec)
          bindString(9, status)
          bindString(10, title)
          bindString(11, imageUrl)
          bindString(12, backdropUrl)
          bindLong(13, hiddenFromContinue)
          bindLong(14, isDeleted)
          bindString(15, changedAt)
          bindString(16, audio)
          bindString(17, quality)
          bindString(18, subtitles)
        }.await()
    notifyQueries(-1_662_017_540) { emit ->
      emit("WatchProgress")
    }
  }

  public suspend fun deleteAllWatchProgress() {
    driver.execute(-1_924_108_531, """DELETE FROM WatchProgress""", 0).await()
    notifyQueries(-1_924_108_531) { emit ->
      emit("WatchProgress")
    }
  }

  private inner class IsVideoFavoriteQuery<out T : Any>(
    public val id: Long,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("FavoriteVideo", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("FavoriteVideo", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(-72_125_242, """
    |SELECT COUNT(1)
    |FROM FavoriteVideo
    |WHERE id=? AND isDeleted=0
    """.trimMargin(), mapper, 1) {
      bindLong(0, id)
    }

    override fun toString(): String = "KinoshkaDb.sq:isVideoFavorite"
  }

  private inner class FindWatchProgressQuery<out T : Any>(
    public val videoId: Long,
    public val seasonNumber: Long,
    public val episodeNumber: Long,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("WatchProgress", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("WatchProgress", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(-1_283_784_900, """
    |SELECT * FROM WatchProgress
    |WHERE videoId=? AND seasonNumber=? AND episodeNumber=?
    """.trimMargin(), mapper, 3) {
      bindLong(0, videoId)
      bindLong(1, seasonNumber)
      bindLong(2, episodeNumber)
    }

    override fun toString(): String = "KinoshkaDb.sq:findWatchProgress"
  }
}
